<template>
  <div>
    <button @click="oauthSignIn">Authorize with Google</button>
  </div>
</template>

<script>
export default {
  props: {
    clientId: {
      type: String,
      required: true,
    },
    redirectUri: {
      type: String,
      required: true,
    },
    scope: {
      type: String,
      required: true,
    },
  },
  methods: {
    oauthSignIn() {
      // Google's OAuth 2.0 endpoint for requesting an access token
      var oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';

      // Create <form> element to submit parameters to OAuth 2.0 endpoint.
      var form = document.createElement('form');
      form.setAttribute('method', 'GET'); // Send as a GET request.
      form.setAttribute('action', oauth2Endpoint);

      // Parameters to pass to OAuth 2.0 endpoint.
      var params = {
        'client_id': this.clientId,
        'redirect_uri': this.redirectUri,
        'response_type': 'token',
        'scope': this.scope,
        'include_granted_scopes': 'true',
        'state': 'pass-through value'
      };

      // Add form parameters as hidden input values.
      for (var p in params) {
        var input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', p);
        input.setAttribute('value', params[p]);
        form.appendChild(input);
      }

      // Add form to page and submit it to open the OAuth 2.0 endpoint.
      document.body.appendChild(form);
      form.submit();
    },
  },
};
</script>
